import { useState } from "react";
import { Link2, Plus } from "lucide-react";
import LinkCard from "./LinkCard";

export default function ConnectTabContent({ links, isAuthor, postId, onAdd, onEdit, onDelete }) {
  const [formMode, setFormMode] = useState(null); // null | 'add' | 'edit'
  const [editingId, setEditingId] = useState(null);
  const [formLabel, setFormLabel] = useState("");
  const [formUrl, setFormUrl] = useState("");

  const openAdd = () => {
    setFormLabel("");
    setFormUrl("");
    setEditingId(null);
    setFormMode("add");
  };

  const openEdit = (link) => {
    setFormLabel(link.label || "");
    setFormUrl(link.url || "");
    setEditingId(link.id);
    setFormMode("edit");
  };

  const cancel = () => {
    setFormMode(null);
    setEditingId(null);
    setFormLabel("");
    setFormUrl("");
  };

  const submit = () => {
    const label = formLabel.trim();
    const url = formUrl.trim();
    if (!url) return;
    if (formMode === "add") onAdd(label || url, url);
    else if (formMode === "edit" && editingId) onEdit(editingId, label || url, url);
    cancel();
  };

  if (links.length === 0 && !isAuthor) {
    return (
      <div className="text-center py-10">
        <div
          className="w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4"
          style={{
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <Link2 className="w-5 h-5 text-white/20" />
        </div>
        <p className="text-white/40 text-sm font-medium">No links yet</p>
        <p className="text-white/20 text-xs mt-1">The creator hasn't added any links</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2.5">
      {links.map((link, i) => (
        <LinkCard
          key={link.id || i}
          link={link}
          postId={postId}
          isOwner={isAuthor}
          onEdit={isAuthor ? () => openEdit(link) : undefined}
          onDelete={isAuthor ? () => onDelete(link.id) : undefined}
        />
      ))}

      {isAuthor && (
        <div className="mt-1">
          {formMode ? (
            <div
              className="p-3.5 rounded-2xl border border-white/10"
              style={{ background: "rgba(255,255,255,0.03)" }}
            >
              <input
                value={formLabel}
                onChange={(e) => setFormLabel(e.target.value)}
                placeholder="Label (e.g. My Portfolio)"
                className="w-full bg-white/[0.06] border border-white/[0.08] rounded-xl
                  px-3 py-2 text-sm text-white/80 placeholder-white/25 mb-2
                  focus:outline-none focus:border-white/20"
              />
              <input
                value={formUrl}
                onChange={(e) => setFormUrl(e.target.value)}
                placeholder="https://example.com"
                className="w-full bg-white/[0.06] border border-white/[0.08] rounded-xl
                  px-3 py-2 text-sm text-white/80 placeholder-white/25 mb-3
                  focus:outline-none focus:border-white/20"
              />
              <div className="flex gap-2">
                <button
                  onClick={submit}
                  className="flex-1 py-2 rounded-xl text-sm font-semibold
                    bg-white/90 text-black hover:bg-white transition-colors"
                >
                  {formMode === "add" ? "Add" : "Save"}
                </button>
                <button
                  onClick={cancel}
                  className="flex-1 py-2 rounded-xl text-sm font-semibold
                    bg-white/[0.06] text-white/50 hover:bg-white/10 transition-colors"
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            links.length < 10 && (
              <button
                onClick={openAdd}
                className="w-full py-2.5 rounded-xl text-sm text-white/40
                  border border-dashed border-white/10 hover:border-white/20
                  hover:text-white/60 transition-colors flex items-center justify-center gap-1.5"
              >
                <Plus className="w-3.5 h-3.5" />
                {links.length === 0 ? "Add your social/personal links" : "Add Link"}
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
}
